<template>
	<div class="w-100">
		<div class="d-inline-block align-middle facility-home">
			<i class="text-semi-dark text-24" :class="iconName"></i>
		</div>
		<p class="mb-0 body-1-2 d-inline-block align-middle ml-2">{{data.name}}</p>
	</div>
</template>
<script>
	export default{
		props: ['data'],
    computed:{
      iconName(){
        const splittedIcon = this.data.icon.split("-");
        return splittedIcon[0] !== 'iconsmind' ? this.data.icon : splittedIcon.map((icon, index) => index > 0 ? this.$capitalize(icon) : icon).join("-");
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/components/hotel/general/Facility.vue